import React from 'react';
import * as PropTypes from 'prop-types';
import { post, asViaUrl } from '../../utility/via-fetch';


function raiseUnhandledException(exceptionInfo) {
  const loggingPayload = {
    location: window.location.href,
    payload: exceptionInfo.message,
  };

  return post('/api/logger/', {}, loggingPayload);
}

/**
 * General Error Boundary on the base of the application.
 */
export default class ViaErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
    };
  }

  componentDidCatch(error) {
    if (error) raiseUnhandledException(error);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    // If there are no issues then display the children components as normal.
    if (!hasError) return children;

    // If development page, we don't want to redirect because React prints a helpful error message.
    if (process.env.NODE_ENV === 'development') return <></>;

    // Redirect the client to a new page because we are in a mess.
    window.location = asViaUrl('/client-error');
    return <></>;
  }
}

ViaErrorBoundary.propTypes = {
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};
